module.exports = __webpack_public_path__ + "media/logo.77adff9afa6e286f0839808926894134.svg";